import { useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import PropertyLabel from 'framework-asset-preview-lib/internal/properties/components/propertyValues/PropertyLabel';
import PropertyValue from 'framework-asset-preview-lib/internal/properties/components/propertyValues/PropertyValue';
import StyledValue from 'framework-asset-preview-lib/internal/properties/components/propertyValues/StyledValue';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PropertySection({
  crmObject,
  direction = 'column',
  hideLabel,
  properties,
  propertyName,
  renderLabel,
  renderLabelBadge,
  renderValue,
  renderValueAs = 'dd',
  valueComponentProps,
  truncateLabel,
  hideDescription = true
}) {
  const property = useMemo(() => {
    return properties.find(p => p.name === propertyName);
  }, [properties, propertyName]);
  const value = useMemo(() => {
    if (renderValue) {
      return /*#__PURE__*/_jsx(StyledValue, {
        as: renderValueAs,
        "data-test-property-name": propertyName,
        children: renderValue()
      });
    }
    const propertyValue = /*#__PURE__*/_jsx(PropertyValue, {
      crmObject: crmObject,
      propertyName: propertyName,
      property: property,
      valueComponentProps: valueComponentProps
    });
    if (direction === 'row') {
      return /*#__PURE__*/_jsx("div", {
        style: {
          textAlign: 'right',
          width: '100%'
        },
        children: propertyValue
      });
    }
    return propertyValue;
  }, [crmObject, direction, property, propertyName, renderValue, renderValueAs, valueComponentProps]);
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "property-section",
    "data-test-property-name": propertyName,
    flexDirection: direction,
    justifyContent: direction === 'column' ? 'start' : 'space-between',
    children: [!hideLabel && /*#__PURE__*/_jsx(PropertyLabel, {
      color: direction === 'row' ? 'inherit' : undefined,
      crmObject: crmObject,
      property: property,
      propertyName: propertyName,
      renderLabel: renderLabel,
      renderLabelBadge: renderLabelBadge,
      truncateLabel: truncateLabel,
      hideDescription: hideDescription
    }), value]
  });
}